import { useState } from 'react';
import { X, ArrowRight, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = 'w-full bg-white/5 border border-white/10 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-[#FF1493]/50';

const Field = ({ label, children }) => (
  <div>
    <label className="block text-xs uppercase tracking-wider text-white/50 mb-2">{label}</label>
    {children}
  </div>
);

export const ReserveSeatModal = ({ pageKey, slug, content, onClose, onDone }) => {
  const [form, setForm] = useState({ full_name: '', whatsapp: '', email: '', describes: '', improve: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const set = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const res = await fetch(`${API}/site-pages/${pageKey}/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, slug: slug || '' }),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(body.detail || 'Registration failed. Please try again.');
      setMessage(body.message);
      onDone();
    } catch (err) {
      setError(err.message);
    }
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/80 backdrop-blur-sm" data-testid="reserve-seat-modal">
      <div className="bg-[#0a0a1a] border border-white/10 rounded-2xl p-6 md:p-8 w-full max-w-lg max-h-[90vh] overflow-y-auto relative text-left">
        <button onClick={onClose} className="absolute top-4 right-4 text-white/40 hover:text-white" data-testid="reserve-seat-close"><X size={20} /></button>
        {message ? (
          <div className="text-center py-8" data-testid="reserve-seat-success">
            <CheckCircle2 size={40} className="text-[#00FF9D] mx-auto mb-4" />
            <p className="text-base text-white/80 leading-relaxed">{message}</p>
          </div>
        ) : (
          <>
            <h2 className="font-['Barlow_Condensed'] text-3xl font-bold uppercase mb-2 pr-8">{content.reserve_form_title}</h2>
            <p className="text-sm text-white/50 mb-6 leading-relaxed">{content.reserve_form_subtitle}</p>
            <form onSubmit={submit} className="space-y-5" data-testid="reserve-seat-form">
              {error && <div className="p-3 rounded-lg bg-[#FF0055]/10 border border-[#FF0055]/30 text-[#FF0055] text-sm" data-testid="reserve-seat-error">{error}</div>}
              <Field label="Full Name"><input required data-testid="reserve-full-name" value={form.full_name} onChange={set('full_name')} className={inputCls} placeholder="Your full name" /></Field>
              <Field label="WhatsApp Number"><input required type="tel" data-testid="reserve-whatsapp" value={form.whatsapp} onChange={set('whatsapp')} className={inputCls} placeholder="+91 9876543210" /></Field>
              <Field label="Email Address"><input required type="email" data-testid="reserve-email" value={form.email} onChange={set('email')} className={inputCls} placeholder="your@email.com" /></Field>
              <Field label="What best describes you? (optional)">
                <select data-testid="reserve-describes" value={form.describes} onChange={set('describes')} className={inputCls}>
                  <option value="" className="bg-[#0a0a1a]">Select an option</option>
                  {(content.reserve_describes_options || []).map(o => <option key={o} value={o} className="bg-[#0a0a1a]">{o}</option>)}
                </select>
              </Field>
              <Field label="What do you currently want to improve most? (optional)">
                <select data-testid="reserve-improve" value={form.improve} onChange={set('improve')} className={inputCls}>
                  <option value="" className="bg-[#0a0a1a]">Select an option</option>
                  {(content.reserve_improve_options || []).map(o => <option key={o} value={o} className="bg-[#0a0a1a]">{o}</option>)}
                </select>
              </Field>
              <button type="submit" disabled={submitting} data-testid="reserve-submit" className="w-full btn-neon py-4 rounded-xl text-sm flex items-center justify-center gap-2 disabled:opacity-50">
                {submitting ? 'Reserving your seat...' : <>{content.reserve_form_cta} <ArrowRight size={16} /></>}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};
